import React from 'react';

const About = () => {
  return (
    <section id="about" className="section">
      <div className="container">
        <h2>About</h2>
        <p>
          I’m a software developer with experience in building web applications and microservices.
          I enjoy shipping small, focused projects to production and iterating on them. This
          portfolio showcases some of my live applications hosted on the cloud under the pavant.dev domain.
        </p>
        <div className="skills">
          <div className="chip">HTML</div>
          <div className="chip">CSS</div>
          <div className="chip">JavaScript</div>
          <div className="chip">React</div>
          <div className="chip">Node</div>
          <div className="chip">Express</div>
          <div className="chip">Java</div>
          <div className="chip">Spring Boot</div>
          <div className="chip">Docker</div>
          <div className="chip">Kubernetes</div>
          <div className="chip">Azure</div>
          <div className="chip">Cloud Hosting</div>
        </div>
      </div>
    </section>
  );
};

export default About;
